  import { jsx as _jsx, jsxs as _jsxs } from "@fluentui/react-jsx-runtime/jsx-runtime";
import { assertSlots } from '@fluentui/react-utilities';
/**
 * @deprecated please use the Toast or MessageBar component
 */ // eslint-disable-next-line deprecation/deprecation
export const renderAlert_unstable = (state)=>{
    // eslint-disable-next-line deprecation/deprecation
    assertSlots(state);
    return /*#__PURE__*/ _jsxs(state.root, {
        children: [
            state.icon && /*#__PURE__*/ _jsx(state.icon, {}),
            state.avatar && /*#__PURE__*/ _jsx(state.avatar, {}),
            state.root.children,
            state.action && /*#__PURE__*/ _jsx(state.action, {})
        ]
    });
};
